import { useState } from "react";
import Close from "../../Helpers/CloseBtn/Close";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { InputDate } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import PopupFooter from "../../Helpers/Popup/PopupFooter";

const ReschedulePopup = ({ task, onClose, onSubmit }) => {
  const [startTime, setStartTime] = useState(task.startTime || "");
  const [duration, setDuration] = useState(task.duration || "");
  const [errors, setErrors] = useState();

  const handleSave = () => {
    let newErrors = {};

    if (!startTime) {
      newErrors.startTime = "Start time is required";
    } else if (new Date(startTime) < new Date()) {
      newErrors.startTime = "Start time cannot be in the past";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    console.log(newErrors);
    onSubmit(startTime);
  };

  return (
    <Popup show={!!task}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={`${trans("Reschedule")} ${task.name}`} />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={onClose}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <div className="row">
          <div className="col-lg-12">
            <InputDate
              title={trans("Start Time")}
              id="startTime"
              name="startTime"
              showTime={{ format: "HH:mm" }}
              onChange={(date) => setStartTime(date?.toISOString())}
              value={startTime || ""}
              min={dayjs()}
              minTime={dayjs()}
              errors={errors}
            />
          </div>
          {/* <div className="col-lg-6">
            <Input
              title={trans("Duration (minutes)")}
              type="number"
              placeholder={trans("e.g. 90")}
              formstyle="form-input"
              id="expectedDuration"
              name="expectedDuration"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
            />
          </div> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="popups-footer gap-8">
          <PopupFooter
            savebtn={trans("Reschedule")}
            savebtnClick={handleSave}
            cancelbtn={trans("Cancel")}
            CancelClick={onClose}
          />
        </div>
      </Modal.Footer>
    </Popup>
  );
};

export default ReschedulePopup;
